/**
 * Created by toomasp on 30.06.2016.
 */
import "./gfx/app5-main.css";
import "./gfx/debug-renderer.css";
import "./gfx/main.base.css";
import {application} from "./application/application";
import {directives} from "./directives/directives";
import {filters} from "./filters/filters";
import {services} from "./services/services";
import {components} from "./components/components";

let ocLazyLoad = require('ocLazyLoad');

let coreModule = angular.module('eservice.core', [
    'ngRoute', 'ngStorage', 'ngSanitize', ocLazyLoad,
    application.name,
    services.name,
    directives.name,
    filters.name,
    components.name
]);


// some hacks to support UI redirects initiated from backend (via $http requests).
coreModule.config(['$httpProvider', ($httpProvider)=> {
    $httpProvider.interceptors.push(['$window', ($window)=> {
        return {
            response: (response) => {
                if (response.headers('Location')) {
                    $window.location.href = response.headers('Location');
                    response.data = `<div></div>`;
                    return response;
                }

                return response;
            },
            responseError: (response) => {
                response.data = `<div>${response.data}</div>`
                return response;
            }
        }
    }]);
}]);

export default coreModule;


// WEBPACK FOOTER //
// ./src/main/ui/core/core.ts